import { getCountries, getCountryCallingCode, parsePhoneNumber } from 'libphonenumber-js';

export interface PhoneCountry {
  iso2: string;
  name: string;
  callingCode: string;
  mask: string;
  nationalDigits: number;
}

// Country names mapping (ISO2 -> Name)
export const COUNTRY_NAMES: Record<string, string> = {
  'AD': 'Andorra', 'AE': 'United Arab Emirates', 'AF': 'Afghanistan', 'AG': 'Antigua and Barbuda',
  'AI': 'Anguilla', 'AL': 'Albania', 'AM': 'Armenia', 'AO': 'Angola', 'AQ': 'Antarctica',
  'AR': 'Argentina', 'AS': 'American Samoa', 'AT': 'Austria', 'AU': 'Australia', 'AW': 'Aruba',
  'AX': 'Åland Islands', 'AZ': 'Azerbaijan', 'BA': 'Bosnia and Herzegovina', 'BB': 'Barbados',
  'BD': 'Bangladesh', 'BE': 'Belgium', 'BF': 'Burkina Faso', 'BG': 'Bulgaria', 'BH': 'Bahrain',
  'BI': 'Burundi', 'BJ': 'Benin', 'BL': 'Saint Barthélemy', 'BM': 'Bermuda', 'BN': 'Brunei',
  'BO': 'Bolivia', 'BQ': 'Caribbean Netherlands', 'BR': 'Brazil', 'BS': 'Bahamas', 'BT': 'Bhutan',
  'BW': 'Botswana', 'BY': 'Belarus', 'BZ': 'Belize', 'CA': 'Canada', 'CC': 'Cocos Islands',
  'CD': 'DR Congo', 'CF': 'Central African Republic', 'CG': 'Republic of the Congo',
  'CH': 'Switzerland', 'CI': 'Ivory Coast', 'CK': 'Cook Islands', 'CL': 'Chile', 'CM': 'Cameroon',
  'CN': 'China', 'CO': 'Colombia', 'CR': 'Costa Rica', 'CU': 'Cuba', 'CV': 'Cape Verde',
  'CW': 'Curaçao', 'CX': 'Christmas Island', 'CY': 'Cyprus', 'CZ': 'Czech Republic', 'DE': 'Germany',
  'DJ': 'Djibouti', 'DK': 'Denmark', 'DM': 'Dominica', 'DO': 'Dominican Republic', 'DZ': 'Algeria',
  'EC': 'Ecuador', 'EE': 'Estonia', 'EG': 'Egypt', 'EH': 'Western Sahara', 'ER': 'Eritrea',
  'ES': 'Spain', 'ET': 'Ethiopia', 'FI': 'Finland', 'FJ': 'Fiji', 'FK': 'Falkland Islands',
  'FM': 'Micronesia', 'FO': 'Faroe Islands', 'FR': 'France', 'GA': 'Gabon', 'GB': 'United Kingdom',
  'GD': 'Grenada', 'GE': 'Georgia', 'GF': 'French Guiana', 'GG': 'Guernsey', 'GH': 'Ghana',
  'GI': 'Gibraltar', 'GL': 'Greenland', 'GM': 'Gambia', 'GN': 'Guinea', 'GP': 'Guadeloupe',
  'GQ': 'Equatorial Guinea', 'GR': 'Greece', 'GS': 'South Georgia', 'GT': 'Guatemala',
  'GU': 'Guam', 'GW': 'Guinea-Bissau', 'GY': 'Guyana', 'HK': 'Hong Kong', 'HN': 'Honduras',
  'HR': 'Croatia', 'HT': 'Haiti', 'HU': 'Hungary', 'ID': 'Indonesia', 'IE': 'Ireland',
  'IL': 'Israel', 'IM': 'Isle of Man', 'IN': 'India', 'IO': 'British Indian Ocean Territory',
  'IQ': 'Iraq', 'IR': 'Iran', 'IS': 'Iceland', 'IT': 'Italy', 'JE': 'Jersey', 'JM': 'Jamaica',
  'JO': 'Jordan', 'JP': 'Japan', 'KE': 'Kenya', 'KG': 'Kyrgyzstan', 'KH': 'Cambodia',
  'KI': 'Kiribati', 'KM': 'Comoros', 'KN': 'Saint Kitts and Nevis', 'KP': 'North Korea',
  'KR': 'South Korea', 'KW': 'Kuwait', 'KY': 'Cayman Islands', 'KZ': 'Kazakhstan', 'LA': 'Laos',
  'LB': 'Lebanon', 'LC': 'Saint Lucia', 'LI': 'Liechtenstein', 'LK': 'Sri Lanka', 'LR': 'Liberia',
  'LS': 'Lesotho', 'LT': 'Lithuania', 'LU': 'Luxembourg', 'LV': 'Latvia', 'LY': 'Libya',
  'MA': 'Morocco', 'MC': 'Monaco', 'MD': 'Moldova', 'ME': 'Montenegro', 'MF': 'Saint Martin',
  'MG': 'Madagascar', 'MH': 'Marshall Islands', 'MK': 'North Macedonia', 'ML': 'Mali',
  'MM': 'Myanmar', 'MN': 'Mongolia', 'MO': 'Macau', 'MP': 'Northern Mariana Islands', 'MQ': 'Martinique',
  'MR': 'Mauritania', 'MS': 'Montserrat', 'MT': 'Malta', 'MU': 'Mauritius', 'MV': 'Maldives',
  'MW': 'Malawi', 'MX': 'Mexico', 'MY': 'Malaysia', 'MZ': 'Mozambique', 'NA': 'Namibia',
  'NC': 'New Caledonia', 'NE': 'Niger', 'NF': 'Norfolk Island', 'NG': 'Nigeria', 'NI': 'Nicaragua',
  'NL': 'Netherlands', 'NO': 'Norway', 'NP': 'Nepal', 'NR': 'Nauru', 'NU': 'Niue',
  'NZ': 'New Zealand', 'OM': 'Oman', 'PA': 'Panama', 'PE': 'Peru', 'PF': 'French Polynesia',
  'PG': 'Papua New Guinea', 'PH': 'Philippines', 'PK': 'Pakistan', 'PL': 'Poland',
  'PM': 'Saint Pierre and Miquelon', 'PN': 'Pitcairn Islands', 'PR': 'Puerto Rico',
  'PS': 'Palestine', 'PT': 'Portugal', 'PW': 'Palau', 'PY': 'Paraguay', 'QA': 'Qatar',
  'RE': 'Réunion', 'RO': 'Romania', 'RS': 'Serbia', 'RU': 'Russia', 'RW': 'Rwanda',
  'SA': 'Saudi Arabia', 'SB': 'Solomon Islands', 'SC': 'Seychelles', 'SD': 'Sudan', 'SE': 'Sweden',
  'SG': 'Singapore', 'SH': 'Saint Helena', 'SI': 'Slovenia', 'SJ': 'Svalbard and Jan Mayen',
  'SK': 'Slovakia', 'SL': 'Sierra Leone', 'SM': 'San Marino', 'SN': 'Senegal', 'SO': 'Somalia',
  'SR': 'Suriname', 'SS': 'South Sudan', 'ST': 'São Tomé and Príncipe', 'SV': 'El Salvador',
  'SX': 'Sint Maarten', 'SY': 'Syria', 'SZ': 'Eswatini', 'TC': 'Turks and Caicos Islands',
  'TD': 'Chad', 'TF': 'French Southern Territories', 'TG': 'Togo', 'TH': 'Thailand',
  'TJ': 'Tajikistan', 'TK': 'Tokelau', 'TL': 'Timor-Leste', 'TM': 'Turkmenistan', 'TN': 'Tunisia',
  'TO': 'Tonga', 'TR': 'Turkey', 'TT': 'Trinidad and Tobago', 'TV': 'Tuvalu', 'TW': 'Taiwan',
  'TZ': 'Tanzania', 'UA': 'Ukraine', 'UG': 'Uganda', 'UM': 'US Outlying Islands', 'US': 'United States',
  'UY': 'Uruguay', 'UZ': 'Uzbekistan', 'VA': 'Vatican City', 'VC': 'Saint Vincent and the Grenadines',
  'VE': 'Venezuela', 'VG': 'British Virgin Islands', 'VI': 'US Virgin Islands', 'VN': 'Vietnam',
  'VU': 'Vanuatu', 'WF': 'Wallis and Futuna', 'WS': 'Samoa', 'XK': 'Kosovo', 'YE': 'Yemen',
  'YT': 'Mayotte', 'ZA': 'South Africa', 'ZM': 'Zambia', 'ZW': 'Zimbabwe',
  'AC': 'Ascension Island', 'TA': 'Tristan da Cunha',
};

/**
 * Known masks for specific countries (for better formatting)
 */
const MASK_9_DIGITS_3_GROUPS = '000 000 000'
const MASK_9_DIGITS_UA_FORMAT = '000 000 000'
const MASK_10_DIGITS_US_FORMAT = '(000) 000-0000'
const MASK_10_DIGITS_3_GROUPS = '000 000 0000'
const MASK_10_DIGITS_GB_FORMAT = '0000 000000'

const KNOWN_MASKS: Record<string, string> = {
  'PT': MASK_9_DIGITS_3_GROUPS,  // Portugal: 9 digits in groups of 3
  'ES': MASK_9_DIGITS_3_GROUPS,  // Spain: 9 digits in groups of 3
  'FR': '0 00 00 00 00', // France: 9 digits with specific formatting
  'DE': '0000 0000000', // Germany: 11 digits
  'IT': MASK_10_DIGITS_3_GROUPS, // Italy: 10 digits
  'GB': '0000 000000',  // United Kingdom: 10 digits
  'US': MASK_10_DIGITS_US_FORMAT, // United States: 10 digits
  'CA': MASK_10_DIGITS_US_FORMAT, // Canada: 10 digits
  'UA': MASK_9_DIGITS_UA_FORMAT,  // Ukraine: 9 digits
  'RU': '(000) 000-00-00', // Russia: 10 digits
  'PL': MASK_9_DIGITS_3_GROUPS,  // Poland: 9 digits
  'NL': '00 00000000',  // Netherlands: 9 digits
  'BE': '0000 00 00 00', // Belgium: 9 digits
  'CH': '00 000 00 00', // Switzerland: 9 digits
  'AT': MASK_10_DIGITS_GB_FORMAT,  // Austria: 10 digits
  'SE': '000 000 00 00', // Sweden: 9 digits
  'NO': '000 00 000',   // Norway: 8 digits
  'DK': '00 00 00 00',  // Denmark: 8 digits
  'FI': MASK_9_DIGITS_UA_FORMAT,  // Finland: 9 digits
  'IE': MASK_9_DIGITS_UA_FORMAT,  // Ireland: 9 digits
};

/**
 * Generate a simple mask based on number length
 */
function generateMask(nationalDigits: number, iso2?: string): string {
  // Check known masks first
  if (iso2 && KNOWN_MASKS[iso2]) {
    return KNOWN_MASKS[iso2];
  }
  
  if (nationalDigits <= 0) return '';
  
  // Create groups of 3-4 digits for better readability
  if (nationalDigits <= 3) {
    return '0'.repeat(nationalDigits);
  } else if (nationalDigits <= 6) {
    const first = Math.floor(nationalDigits / 2);
    const second = nationalDigits - first;
    return '0'.repeat(first) + ' ' + '0'.repeat(second);
  } else if (nationalDigits <= 9) {
    const first = 3;
    const second = 3;
    const third = nationalDigits - first - second;
    return '0'.repeat(first) + ' ' + '0'.repeat(second) + ' ' + '0'.repeat(third);
  } else {
    // For longer numbers, use groups of 3-4
    const groups: number[] = [];
    let remaining = nationalDigits;
    while (remaining > 0) {
      if (remaining >= 4) {
        groups.push(4);
        remaining -= 4;
      } else {
        groups.push(remaining);
        remaining = 0;
      }
    }
    return groups.map(g => '0'.repeat(g)).join(' ');
  }
}

/**
 * Known national digit counts for countries where auto-detection might fail
 */
const KNOWN_NATIONAL_DIGITS: Record<string, number> = {
  'PT': 9,  // Portugal: 9 digits
  'ES': 9,  // Spain: 9 digits
  'FR': 9,  // France: 9 digits
  'DE': 11, // Germany: 11 digits (with leading 0)
  'IT': 10, // Italy: 10 digits
  'GB': 10, // United Kingdom: 10 digits
  'US': 10, // United States: 10 digits
  'CA': 10, // Canada: 10 digits
  'UA': 9,  // Ukraine: 9 digits
  'RU': 10, // Russia: 10 digits
  'PL': 9,  // Poland: 9 digits
  'NL': 9,  // Netherlands: 9 digits
  'BE': 9,  // Belgium: 9 digits
  'CH': 9,  // Switzerland: 9 digits
  'AT': 10, // Austria: 10 digits
  'SE': 9,  // Sweden: 9 digits
  'NO': 8,  // Norway: 8 digits
  'DK': 8,  // Denmark: 8 digits
  'FI': 9,  // Finland: 9 digits
  'IE': 9,  // Ireland: 9 digits
};

/**
 * Get national digits for a country by trying to parse sample numbers
 * Uses libphonenumber metadata to determine typical number length
 */
function getNationalDigits(iso2: string, callingCode: string): number {
  // Check known digits first
  if (KNOWN_NATIONAL_DIGITS[iso2]) {
    return KNOWN_NATIONAL_DIGITS[iso2];
  }
  
  // Try different number patterns to find the typical length
  // Most countries have numbers between 7-12 digits
  const sampleLengths = [7, 8, 9, 10, 11, 12];
  const foundLengths: number[] = [];
  
  for (const length of sampleLengths) {
    // Try different starting digits (some countries have specific patterns)
    for (const startDigit of ['1', '2', '3', '5', '6', '7', '8', '9']) {
      const sampleNumber = '+' + callingCode + startDigit + '0'.repeat(length - 1);
      try {
        const parsed = parsePhoneNumber(sampleNumber);
        if (parsed.country === iso2) {
          foundLengths.push(parsed.nationalNumber.length);
        }
      } catch {
        // Continue
      }
    }
  }
  
  // Use the most common length found, or default to 10
  if (foundLengths.length > 0) {
    // Count occurrences
    const lengthCounts: Record<number, number> = {};
    foundLengths.forEach(len => {
      lengthCounts[len] = (lengthCounts[len] || 0) + 1;
    });
    
    // Return the most common length
    const mostCommon = Object.entries(lengthCounts)
      .sort((a, b) => b[1] - a[1])[0];
    return parseInt(mostCommon[0], 10);
  }
  
  // Default to 10 if we can't determine (most common length)
  return 10;
}

/**
 * Generate complete list of all countries from libphonenumber-js, sorted alphabetically
 */
function getAllCountries(): PhoneCountry[] {
  const allCountryCodes = getCountries();
  const countries: PhoneCountry[] = [];
  
  for (const iso2 of allCountryCodes) {
    try {
      const callingCode = getCountryCallingCode(iso2);
      const name = COUNTRY_NAMES[iso2] || iso2;
      
      // Try to determine national digits
      const nationalDigits = getNationalDigits(iso2, callingCode);
      const mask = generateMask(nationalDigits, iso2);
      
      countries.push({
        iso2,
        name,
        callingCode,
        mask,
        nationalDigits,
      });
    } catch (error) {
      // Skip countries that can't be processed
      console.warn(`Failed to process country ${iso2}:`, error);
    }
  }
  
  // Sort by name alphabetically
  return countries.sort((a, b) => a.name.localeCompare(b.name));
}

// Generate and export the complete sorted list
export const ALL_COUNTRIES = getAllCountries();
